import { defineMessages } from "react-intl";

const messages = defineMessages({
  orderCustomerFulfillmentAll: {
    id: "R98JLZ",
    defaultMessage: "Fulfill from All Warehouses",
    description: "OrderCustomer Fulfillment from All Warehouses",
  },
  orderCustomerFulfillmentLocal: {
    id: "/w919H",
    defaultMessage: "Fulfill from Local Stock",
    description: "OrderCustomer Fulfillment from Local Warehouse",
  },
  invoiceTypeCompany: {
    id: "DBV4WK",
    defaultMessage: "Company",
    description: "customer invoice type, invoice issued to a company",
  },
  invoiceTypeIndividual: {
    id: "Uc4YDB",
    defaultMessage: "Individual",
    description: "customer invoice type, invoice issued to a private person",
  },
});

export default messages;
